import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { createPortal } from "react-dom";


const ModalBackground = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2147483647;
  overflow: hidden;
  background: rgba(0, 0, 0, ${(props) => (props.isOpen ? "0.5" : "0")});
  display: ${(props) => (props.isOpen ? "block" : "none")};
  transition: background 0.2s ease-in-out;
`;

const GAModal = styled.div<{ size?: string; isOpen: boolean }>`
  position: fixed;
  background: white;
  width: ${(props) => (props.size ? props.size : "544px")};
  height: auto;
  max-height: calc(100vh - 100px);
  top: 52%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px 0 rgba(50, 50, 93, 0.1);
  overflow: auto;
  max-width: "calc(100vw - 20px)");
`;


export default function ({ isOpen, toggle, children, size }: any) {
    const ref = useRef<HTMLDivElement>(null); // Explicitly typed as RefObject<HTMLDivElement>

    useEffect(() => {
        addClassToBody();
    }, [isOpen]);

    function addClassToBody() {
        if (isOpen) {
            document.body.classList.add("modal-open");
            document.body.classList.add("stop-scrolling");
        } else {
            document.body.classList.remove("modal-open");
            document.body.classList.remove("stop-scrolling");
        }
    }

    return createPortal(
        <ModalBackground isOpen={isOpen}>
            <GAModal ref={ref} size={size} isOpen={isOpen}>
                {children}
            </GAModal>
        </ModalBackground>,
        document.body
    );
}
